import { t } from "../../../services/utils";
import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import InserChartIcon from "@material-ui/icons/InsertChart";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import {convertNumberToLocaleString, convertLocaleStringToNumber} from '../../../services/utils';

class LineView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        display: "flex",
        flexDirection: "row",
        paddingLeft: 35,
        paddingTop: 25,
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      goalContainer: {
        display: "flex",
        flexDirection: "row",
      },
      line: {
        fontSize: 16,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: this.props.paddingTop ? this.props.paddingTop : 0,
        paddingBottom: this.props.paddingBottom ? this.props.paddingBottom : 0,
      },
      assessment: {
        fontSize: 14,
        marginTop: 5,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
      },
      measure: {
        fontSize: 38,
        color: "#2A234E",
        fontWeight: 300,
        fontFamily: "'Inter', sans-serif",
      },
      assessmentView: {
        marginRight: 90,
        maxWidth: "25%",
      },
      icon: {
        fontSize: 20,
        color: "#524D70",
      },
      assessmentIcon: {
        height: 24,
        color: "#1FA37C",
        marginLeft: -3,
      },
      calendarIcon: {
        color: "#02A8F3",
        marginTop: -3,
        marginLeft: -1,
      },
      progressBar: {
        height: 22,
        width: 22,
        marginTop: -5,
        marginBottom: -5,
      },
    };
    const { assessment, measure, goal, id } = this.props;
    return (
      <div style={styles.container} data-testid="assessment-detail">
        <div style={styles.assessmentView}>
          {/* <img
            style={styles.assessmentIcon}
            src={ require( "../../../img/weight-small.png") }
          /> */}
          <InserChartIcon style={styles.assessmentIcon} />
          <div
            style={{
              ...styles.assessment,
              ...{
                marginTop: 0,
              },
            }}
          >
            {t(assessment)}
          </div>
          <div style={styles.measure}>{convertNumberToLocaleString(measure)}</div>
        </div>
        {/* {goal && ( */}
        <div style={styles.assessmentView}>
          <img src={ require( "../../../img/goal.png") } width="20" />
          {/* <i
            className="fa fa-bullseye"
            style={styles.icon}
            aria-hidden="true"
           /> */}
          <div style={styles.assessment}>{t("goal")}</div>
          <div style={styles.measure}>
            {goal && goal.ta ? convertNumberToLocaleString(goal.ta) : `${"-"}`}
          </div>
        </div>
        <div style={styles.assessmentView}>
          <CalendarTodayIcon style={styles.calendarIcon} />
          {/* <i
              className="fa fa-calendar-o"
              style={styles.icon}
              aria-hidden="true"
            /> */}
          <div
            style={{
              ...styles.assessment,
              ...{
                marginTop: 3,
              },
            }}
          >
            {t("daysLeft")}
          </div>
          <div style={styles.measure}>
            {goal && goal.dl ? goal.dl : `${"-"}`}
          </div>
        </div>
        <div style={styles.assessmentView}>
          <CircularProgressbar
            value={Math.floor(goal && goal.pc ? goal.pc : "0")}
            text={null}
            strokeWidth={20}
            styles={{
              root: styles.progressBar,
              path: {
                stroke: "#7B62E1",
              },
            }}
          />
          <div style={styles.assessment}>{t("completed")}</div>
          <div style={styles.measure}>
            {goal && goal.pc ? `${goal.pc}%` : `${"-"}`}
          </div>
        </div>
        {/* )} */}
      </div>
    );
  };
  static getHeight(props) {
    let height = 75;
    if (props.paddingTop) {
      height += props.paddingTop;
    }
    if (props.paddingBottom) {
      height += props.paddingBottom;
    }
    return height;
    // calculateTextHeight(props.line, STORY_VIEW_WIDTH - 20, { fontSize: 16 })
  }
}

export default LineView;
